/* eslint-disable @typescript-eslint/no-explicit-any */

'use client';

import { Box, Stack, Typography } from '@mui/material';
import cx from 'clsx';
import { useTranslations } from 'next-intl';
import Image from 'next/image';

import Link from '@/components/Link';
import Quote from '@/components/SvgIcons/Quote';
import { CaseStudyTestimonial } from '@/config/case-studies.config';
import useBreakpoint from '@/utils/hooks/useBreakpoint';

import styles from './TestimonialCard.module.scss';

interface TestimonialCardProps {
  testimonial: CaseStudyTestimonial;
  isOddIndex: boolean;
}

const TestimonialCard = ({ testimonial, isOddIndex }: TestimonialCardProps) => {
  const { isMobile } = useBreakpoint();
  const t = useTranslations('case-study');

  return (
    <Box className={cx(styles.container, isOddIndex && styles.isOddIndex)}>
      <Box className={styles.quoteIcon}>
        <Quote />
      </Box>
      <Typography
        variant="h5"
        component="h4"
        className={styles.quote}
        sx={{
          typography: { xs: 'subtitle2', md: 'h5' },
        }}
      >
        {t(testimonial.quote as any)}
      </Typography>
      <Stack gap={3}>
        <Stack direction="row" alignItems="center" gap={1.5}>
          <Box className={styles.avatar}>
            <Image
              src={t(testimonial.avatar.src as any)}
              alt={t(testimonial.avatar.alt as any)}
              width={isMobile ? 48 : 64}
              height={isMobile ? 48 : 64}
            />
          </Box>
          <Stack gap={0.5}>
            <Typography
              variant="h5"
              component="h4"
              sx={{
                typography: { xs: 'subtitle2', md: 'h5' },
              }}
            >
              {t(testimonial.author as any)}
            </Typography>
            <Typography variant="body1" className={styles.role}>
              {t(testimonial.role as any)}
            </Typography>
          </Stack>
        </Stack>
        {testimonial.link && (
          <Link
            href={t(testimonial.link.href as any)}
            target={testimonial.link.target}
            text={t(testimonial.link.text as any)}
          />
        )}
      </Stack>
    </Box>
  );
};

export default TestimonialCard;
